import { render, staticRenderFns } from "./AddFeesAndCharges.vue?vue&type=template&id=4d27a4ed&scoped=true"
import script from "./AddFeesAndCharges.vue?vue&type=script&lang=js"
export * from "./AddFeesAndCharges.vue?vue&type=script&lang=js"
import style0 from "./AddFeesAndCharges.vue?vue&type=style&index=0&id=4d27a4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27a4ed",
  null
  
)

export default component.exports